import { INPUT_FIELD_CLASSNAME } from '@/constants/classname/classname';
import { TabCronProp } from '@/types/cron';
import { FunctionComponent } from 'react';

const MinutesCron: FunctionComponent<TabCronProp> = (props) => {
    const onChange = (e: { target: { value: string; }; }) => {
        if (props.disabled) { return }
        if ((parseInt(e.target.value) > 0 && parseInt(e.target.value) < 60) || e.target.value === '') {
            const val = ['0', '*', '*', '*', '*', '?', '*']
            val[1] = e.target.value ? `0/${e.target.value}` : val[1];
            props.onChange(val)
        }
    }

    const value = props.value[1]?.split('/')[1];
    return (
        <div className="minutes py-4">
            <div className='text-left font-semibold text-base mb-1'>{props.translate('Every')}</div>
            <div className='w-full flex flex-row items-center'>
                <input
                    className={INPUT_FIELD_CLASSNAME + ' w-[120px]'}
                    type="Number"
                    onChange={onChange}
                    value={value}
                    min={1}
                    max={60}
                    disabled={props.disabled}
                />
                <div className='text-base ml-2'>{props.translate('minute(s)')}</div>
            </div>
        </div>
    )
}
export default MinutesCron;
